import initSharedCartItems from '../shared/initSharedCartItems';


window.tnew.page.initialize = (pageConfig) => {
  initSharedCartItems(pageConfig);
};
